var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 5,
    fill: "#FDFDFD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.2122 12.8402V12.8433C28.457 13.0951 28.6519 13.3911 28.7864 13.7158C28.9259 14.0525 28.9976 14.4133 28.9976 14.7777C28.9976 15.1421 28.9259 15.5029 28.7864 15.8396C28.6469 16.1762 28.4425 16.4821 28.1848 16.7398L17.8256 27.0975C17.562 27.3612 17.2412 27.561 16.8866 27.6778L13.0444 28.9594C12.9045 29.006 12.7544 29.0126 12.6109 28.9786C12.4674 28.9447 12.3362 28.8714 12.2321 28.7671C12.1279 28.6627 12.0548 28.5314 12.0211 28.3879C11.9873 28.2444 11.9942 28.0943 12.041 27.9544L13.3213 24.112C13.4393 23.7584 13.6379 23.4371 13.9014 23.1734L24.2606 12.8128C24.5183 12.5551 24.8242 12.3507 25.1608 12.2112C25.4975 12.0718 25.8583 12 26.2227 12C26.5871 12 26.948 12.0718 27.2846 12.2112C27.6213 12.3507 27.9272 12.5551 28.1848 12.8128L28.2122 12.8402ZM27.5035 14.7764C27.5035 14.7763 27.5035 14.7764 27.5035 14.7764V14.7764ZM25.3171 13.8707C25.3171 13.8708 25.3171 13.8707 25.3171 13.8707V13.8707ZM24.4224 14.8975L25.4187 13.9025C25.5212 13.8083 25.6395 13.7327 25.7684 13.6793C25.9124 13.6196 26.0668 13.5889 26.2227 13.5889C26.3787 13.5889 26.5331 13.6196 26.6771 13.6793C26.8212 13.739 26.9521 13.8264 27.0623 13.9367C27.1726 14.0469 27.2601 14.1778 27.3197 14.3219C27.3794 14.466 27.4101 14.6204 27.4101 14.7763C27.4101 14.9322 27.3794 15.0866 27.3197 15.2307C27.2601 15.3747 27.1726 15.5056 27.0623 15.6159L26.1016 16.5766L24.4224 14.8975ZM16.703 25.9738C16.6138 26.0633 16.505 26.1308 16.3852 26.171L14.0493 26.9496L14.828 24.6135C14.8677 24.4934 14.9349 24.384 15.0241 24.2943L23.2999 16.02L24.9777 17.6991L16.703 25.9738Z",
    fill: "#222529"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEdit);
export default __webpack_public_path__ + "static/media/icon_edit.e65e2e4a40cc17cfcaa9809e8e3fc94f.svg";
export { ForwardRef as ReactComponent };